// src/utils/authCheck.ts
import { redirect } from "@tanstack/react-router";
import store from "../store/store";

export async function requireAuth() {
  const state = store.getState();
  const isLoggedIn = state.auth.user !== null;

  console.log("AuthCheck running →", { isLoggedIn, user: state.auth.user });

  if (!isLoggedIn) {
    throw redirect({ to: "/login" });
  }
}
